import { useEffect, useState } from 'react';
import * as LDClient from 'launchdarkly-js-client-sdk';
import { Auth } from 'aws-amplify';

export const ROLE_SUPERVISOR = 'supervisor';
export const ROLE_LEAD = 'lead';
const FLAG_KEY = 'supervisor-dashboard-role';

// Reads the `supervisor-dashboard-role` LaunchDarkly flag ('supervisor' | 'lead') for
// the signed-in user. Follows the useSeedInventoryFlag pattern: each
// consumer initializes its own LD client keyed by the Cognito email.
//
// Defaults to lead on a missing flag, an unknown value, an LD init failure,
// or an auth failure — supervisor capabilities (e.g. assigning drivers) are
// opt-in per user, so the safe fallback is the restricted role.
export default function useUserRole() {
  const [role, setRole] = useState(ROLE_LEAD);

  useEffect(() => {
    let cancelled = false;
    let ldclient;
    async function init() {
      try {
        const email =
          Auth?.user?.attributes?.email ||
          (await Auth.currentAuthenticatedUser()).signInUserSession.idToken
            .payload.email;
        ldclient = LDClient.initialize(
          process.env.REACT_APP_LAUNCH_DARKLY_CMS || 'nlfaepofjeowiajfpoijewr',
          { key: email },
        );
        ldclient.on('ready', () => {
          if (cancelled) return;
          const flags = ldclient.allFlags();
          setRole(
            flags[FLAG_KEY] === ROLE_SUPERVISOR ? ROLE_SUPERVISOR : ROLE_LEAD,
          );
        });
      } catch (e) {
        // Silently stay lead if we can't initialize LD.
        // eslint-disable-next-line no-console
        console.warn('LD init failed for supervisor-dashboard-role flag:', e);
      }
    }
    init();
    return () => {
      cancelled = true;
      if (ldclient && typeof ldclient.close === 'function') {
        ldclient.close();
      }
    };
  }, []);

  return { role, isLead: role === ROLE_LEAD };
}
